// @flow

import {
  BADEN_WUERTTEMBERG,
  BAVARIA,
  BERLIN,
  BRANDENBURG,
  BREMEN,
  HAMBURG,
  HESSE,
  LOWER_SAXONY,
  MECKLENBURG_VORPOMMERN,
  NORTH_RHINE_WESTPHALIA,
  RHINELAND_PALATINATE,
  SAARLAND,
  SAXONY,
  SAXONY_ANHALT,
  SCHLESWIG_HOLSTEIN,
  THURINGIA,
  AUTOMATED_BUBA
} from "./guaranteeBanks";

export type DayMonth = {
  day: number,
  month: number
};

// Fixed feasts
const HOLIDAY__NEW_YEARS_DAY: DayMonth = { day: 1, month: 0 };
const HOLIDAY__EPIPHANY: DayMonth = { day: 6, month: 0 };
const HOLIDAY__LABOUR_DAY: DayMonth = { day: 1, month: 4 };
const HOLIDAY__ASSUMPTION: DayMonth = { day: 15, month: 7 };
const HOLIDAY__GERMAN_UNITY_DAY: DayMonth = { day: 3, month: 9 };
const HOLIDAY__REFORMATION_DAY: DayMonth = { day: 31, month: 9 };
const HOLIDAY__ALL_SAINTS: DayMonth = { day: 1, month: 10 };
export const HOLIDAY__CHRISTMAS: DayMonth = { day: 25, month: 11 };
const HOLIDAY__BOXING_DAY: DayMonth = { day: 26, month: 11 };

// Deltas from Easter for Easter-dependent holidays in days
export const HOLIDAY_EASTER_DELTA__GOOD_FRIDAY = -2;
export const HOLIDAY_EASTER_DELTA__EASTER_MONDAY = 1;
export const HOLIDAY_EASTER_DELTA__ASCENSION = 39;
export const HOLIDAY_EASTER_DELTA__WHITMONDAY = 50;
export const HOLIDAY_EASTER_DELTA__CORPUS_CHRISTI = 60;

/*
 * Attention, while years and days are 1-based,
 * months are 0-based (0 = January, 11 = December).
 */

// most of the movable feasts are dependent on the date of Easter in a given year
export const easters: Date[] = [
  new Date(2019, 3, 21),
  new Date(2020, 3, 12),
  new Date(2021, 3, 4),
  new Date(2022, 3, 17),
  new Date(2023, 3, 9),
  new Date(2024, 2, 31),
  new Date(2025, 3, 20),
  new Date(2026, 3, 5),
  new Date(2027, 2, 28),
  new Date(2028, 3, 16),
  new Date(2029, 3, 1)
];

export const fixedNationalHolidays: DayMonth[] = [
  HOLIDAY__NEW_YEARS_DAY,
  HOLIDAY__LABOUR_DAY,
  HOLIDAY__GERMAN_UNITY_DAY,
  HOLIDAY__CHRISTMAS,
  HOLIDAY__BOXING_DAY
];

export const landSpecificHolidays: {
  [string | number]: {|
    fixed: DayMonth[],
    isCorpusChristiHoliday: boolean
  |}
} = {
  [BADEN_WUERTTEMBERG]: {
    fixed: [HOLIDAY__EPIPHANY, HOLIDAY__ALL_SAINTS],
    isCorpusChristiHoliday: true
  },
  [BAVARIA]: {
    fixed: [HOLIDAY__EPIPHANY, HOLIDAY__ALL_SAINTS],
    isCorpusChristiHoliday: true
  },
  [BERLIN]: {
    fixed: [],
    isCorpusChristiHoliday: false
  },
  [BRANDENBURG]: {
    fixed: [HOLIDAY__REFORMATION_DAY],
    isCorpusChristiHoliday: false
  },
  [BREMEN]: {
    fixed: [HOLIDAY__REFORMATION_DAY],
    isCorpusChristiHoliday: false
  },
  [HAMBURG]: {
    fixed: [HOLIDAY__REFORMATION_DAY],
    isCorpusChristiHoliday: false
  },
  [HESSE]: {
    fixed: [],
    isCorpusChristiHoliday: true
  },
  [MECKLENBURG_VORPOMMERN]: {
    fixed: [HOLIDAY__REFORMATION_DAY],
    isCorpusChristiHoliday: false
  },
  [LOWER_SAXONY]: {
    fixed: [HOLIDAY__REFORMATION_DAY],
    isCorpusChristiHoliday: false
  },
  [NORTH_RHINE_WESTPHALIA]: {
    fixed: [HOLIDAY__ALL_SAINTS],
    isCorpusChristiHoliday: true
  },
  [RHINELAND_PALATINATE]: {
    fixed: [HOLIDAY__ALL_SAINTS],
    isCorpusChristiHoliday: true
  },
  [SAARLAND]: {
    fixed: [HOLIDAY__ASSUMPTION, HOLIDAY__ALL_SAINTS],
    isCorpusChristiHoliday: true
  },
  [SAXONY]: {
    fixed: [HOLIDAY__REFORMATION_DAY],
    isCorpusChristiHoliday: true
  },
  [SAXONY_ANHALT]: {
    fixed: [HOLIDAY__EPIPHANY, HOLIDAY__REFORMATION_DAY],
    isCorpusChristiHoliday: false
  },
  [SCHLESWIG_HOLSTEIN]: {
    fixed: [HOLIDAY__REFORMATION_DAY],
    isCorpusChristiHoliday: false
  },
  [THURINGIA]: {
    fixed: [HOLIDAY__REFORMATION_DAY],
    isCorpusChristiHoliday: false
  },
  [AUTOMATED_BUBA]: {
    fixed: [HOLIDAY__REFORMATION_DAY],
    isCorpusChristiHoliday: false
  }
};
